import { forwardRef } from "react";
import AppFormEditor from "../../../AppFormEditor";
import { AppPartType } from "../../../types";
import styled from "styled-components";

type PropsType = {
  appPart: AppPartType;
  isNotAllowDrop?: boolean;
};
const PlaceHoder = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: calc(100% - 10px);
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const FieldGroup = forwardRef<AppPartType, PropsType>(
  ({ appPart, isNotAllowDrop }, selectedAppPartRef) => {
    return (
      <AppFormEditor
        layout={appPart.children}
        parentAppPart={appPart}
        ref={selectedAppPartRef}
        isNotAllowDrop={isNotAllowDrop}
        extra={
          (appPart.children || []).length === 0 ? (
            <PlaceHoder>
              {isNotAllowDrop
                ? "ここに追加することはできません"
                : "ここにはドラッグドロップするフィルードとなる"}
            </PlaceHoder>
          ) : undefined
        }
      />
    );
  },
);
FieldGroup.displayName = "FieldGroup";

export default FieldGroup;
